<template>
    <div>
      
   
    <input type="number" v-model="kwh">
    <input v-model="kwh" type="range" class="form-range" min="0" max="30000">

    <p>Med en förbrukning på <strong> {{kwh}} kWh</strong> om året<br>blir den totala årskostnaden
        
      <strong>{{Math.round(fast + (kwh * rorlig))}}  kr</strong>.</p>
    <p>Varav under året fast del <strong>{{fast}} kr</strong>.</p>
    <p>Varav under året rörlig del <strong>{{Math.round(kwh * rorlig)}}kr</strong>.</p>

    </div>
</template>

<script>

export default {
    props: {'rorlig': {type: Number}, 'fast': {type: Number}},

    data() {
        var kwh = 10000;
        
    
return {
    kwh

}

    }
}


</script>
